<p-toast position="top-right"></p-toast>

<div class="partner-store-hours-body">
    <partner-mart-locations-sidebar-hours *ngIf="showStoreHourSideBar"
                                          [showStoreHourSideBar]="showStoreHourSideBar"
                                          [store]="storeData"
                                          [partnerMartLocationsStoreHoursComponent]="this"
                                          (changedShowStoreHourSideBarEmit)="changedShowStoreHourSideBarEmit($event)"></partner-mart-locations-sidebar-hours>

    <!--Body Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>

    <div class="flex flex-row">
        <div class="partner-store-hours-block">
            <div class="flex flex-row partner-store-hours-block__header">
                <div class="psh-header-title">Operation Hours</div>
                <div class="psh-header-right-block">
                    <button class="bluedark-btn" pButton label="Add Operation Hours" (click)="openShowStoreHourSideBar()"></button>
                </div>
            </div>
            <div class="psh-header-subtitle">
                Operation Hours
            </div>

            <div class="psh-hours-block">
                <p-scrollPanel [style]="{height: 'calc(100vh - 424px)'}"
                               [styleClass]="'app-scrollpanel'">
                    <div class="flex flex-row psh-hours-block__item" *ngFor="let operationHour of operationHours; let i = index;">
                        <div class="psh-hours-block__item-left-block">
                            <div class="psh-item-weeks">{{operationHour.daysWeek}}</div>
                            <div class="psh-item-hours">{{operationHour.startTime}} - {{operationHour.endTime}}</div>
                        </div>
                        <div class="psh-hours-block__item-right-block">
                            <div class="psh-edit-link">Edit</div>
                        </div>
                    </div>
                </p-scrollPanel>
            </div>
        </div>

        <div class="partner-store-hours-block">
            <div class="flex flex-row partner-store-hours-block__header">
                <div class="psh-header-title">Schedule Special Hours</div>
                <div class="psh-header-right-block">
                    <button class="bluedark-btn" pButton label="Add Special Hours"></button>
                </div>
            </div>
            <div class="psh-header-subtitle">
                Special hours will override your Operation hours
            </div>

            <div class="psh-hours-block">
                <p-scrollPanel [style]="{height: 'calc(100vh - 424px)'}"
                               [styleClass]="'app-scrollpanel'">
                    <div class="flex flex-row psh-hours-block__item" *ngFor="let specialHour of storeData.StoreSpecialHours; let i = index;">
                        <div class="psh-hours-block__item-left-block">
                            <div class="psh-item-weeks">{{specialHour.Title}}</div>
                            <div class="psh-item-dates">{{specialHour.StartDateStr}} - {{specialHour.EndDateStr}}</div>
                        </div>
                        <div class="psh-hours-block__item-right-block">
                            <div class="psh-edit-link">Edit</div>

                            <div class="psh-item-hours" *ngFor="let time of specialHour.StoreSpecialHourTimes; let i = index;">
                                {{time.OpensAtStr}} - {{time.ClosesAtStr}}
                            </div>
                        </div>
                    </div>
                </p-scrollPanel>
            </div>
        </div>
    </div>
</div>
